import { FC } from "react";
import { FieldValues } from "react-hook-form";
import {
  MuiBox,
  MuiDoubleLabel,
  MuiGrid,
} from "../../../../../../../components";
import { useSiteCore } from "../../../../../../../hooks/useSiteCore";
import {
  activitiesAndDeliverablesSiteCoreKeys,
} from "../../../../../siteCore/SiteCoreKeys";
import { ViewActivityResponse } from "../../../modelsAndSchemas/models";
import { UnitTypesKey } from "../../../../../../../helpers/constants/siteCoreKeys";

interface ViewActivityDefaultTabProps extends FieldValues {
  activityData: ViewActivityResponse;
}

export const ViewActivityDefault: FC<ViewActivityDefaultTabProps> = ({
  activityData,
}) => {
  const gridSize = { md: 4, sm: 6, xs: 12 };
  const { fetchLabel, fetchValueByKeyOfDropdown } = useSiteCore();

  const getUnitText = () => {
    if (activityData?.units === UnitTypesKey.Minutes) {
      return activitiesAndDeliverablesSiteCoreKeys.minutes;
    } else if (activityData?.units === UnitTypesKey.Count) {
      return activitiesAndDeliverablesSiteCoreKeys.quantity;
    } else if (activityData?.units === UnitTypesKey.Days) {
      return activitiesAndDeliverablesSiteCoreKeys.numberofDays;
    } else {
      return activitiesAndDeliverablesSiteCoreKeys.halfDay;
    }
  };

  const getMeasurementValue = () => {
    if (!activityData?.units) {
      return "";
    }
    if (activityData.units === UnitTypesKey.Minutes) {
      return fetchValueByKeyOfDropdown(
        activitiesAndDeliverablesSiteCoreKeys.defaultActivityKey,
        activitiesAndDeliverablesSiteCoreKeys.minutesList,
        activityData.measurement,
      );
    }
    return activityData.measurement;
  };
  return (
    <MuiBox>
      <MuiGrid
        container
        data-testid="activity-tab-default"
        className="activity-tab-general"
      >
        <MuiGrid size={gridSize}>
          <MuiDoubleLabel
            label={fetchLabel(
              activitiesAndDeliverablesSiteCoreKeys.defaultActivityKey,
              activitiesAndDeliverablesSiteCoreKeys.units,
            )}
            value={fetchValueByKeyOfDropdown(
              activitiesAndDeliverablesSiteCoreKeys.defaultActivityKey,
              activitiesAndDeliverablesSiteCoreKeys.unitLists,
              activityData?.units ?? "",
            )}
          />
        </MuiGrid>
        <MuiGrid size={gridSize}>
          <MuiDoubleLabel
            data-testid="measurement"
            label={fetchLabel(
              activitiesAndDeliverablesSiteCoreKeys.defaultActivityKey,
              getUnitText(),
            )}
            value={getMeasurementValue()}
          />
        </MuiGrid>
      </MuiGrid>
    </MuiBox>
  );
};
